import Browser from '../../utils/browser';

export default {
  name: 'browser',
  proto: {
    browser: Browser,
  },
  static: {
    browser: Browser,
  },
};



// WEBPACK FOOTER //
// ../src/modules/browser/browser.js